import { render } from "./BsHfCardMin.vue?vue&type=template&id=71196418&scoped=true"
import script from "./BsHfCardMin.vue?vue&type=script&lang=js"
export * from "./BsHfCardMin.vue?vue&type=script&lang=js"

import "./BsHfCardMin.vue?vue&type=style&index=0&id=71196418&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-71196418"

export default script